import React from 'react';
import {RenderCardElement} from '../../localData/CardsData/RenderCardElement';
import {StickyNavigationLink} from '../../components/organisms/StickyNavigationLinks/StickyNavigationLinks'
import {Layout, Ads, MainContent, MainWrapper} from './BlogCardPage.Styles'

interface BlogCardPageProps {
    post: {
      date: string;
      routeCard: string;
      description: string;
      elements: Array<{
        type: string ;
        content: string | string[] | ElementType[]; // Ajuste isso se precisar ser mais específico
        getStyles?: (breakpoints: {
          isDesktopOrLaptop?: boolean;
          isMiniNotebook?: boolean;
          isMobileBig?: boolean;
          isMobileMedium?: boolean;
          isMobileMini?: boolean;
        }) => React.CSSProperties;
      }>;
    };
  }

  interface ElementType {
    type: string ;
    content: string | string[] | ElementType[]; // Ajuste para suportar listas ou elementos aninhados
    getStyles?: (breakpoints: {
      isDesktopOrLaptop?: boolean;
      isMiniNotebook?: boolean;
      isMobileBig?: boolean;
      isMobileMedium?: boolean;
      isMobileMini?: boolean;
    }) => React.CSSProperties;
  }
 

  export const BlogCardPage: React.FC<BlogCardPageProps> = ({ post }) => {
    React.useEffect(() => {
      // Define o título da página baseado no primeiro elemento, se for string
      if (typeof post.elements[0]?.content === 'string') {
        document.title = post.elements[0].content;
      }
  
      // Define ou atualiza a meta tag de descrição
      let metaDescription = document.querySelector('meta[name="description"]') as HTMLMetaElement | null;
      if (metaDescription) {
        metaDescription.content = post.description;
      } else {
        metaDescription = document.createElement('meta');
        metaDescription.name = 'description';
        metaDescription.content = post.description;
        document.head.appendChild(metaDescription);
      }
    }, [post]);
  

    return (
      <Layout>
        <StickyNavigationLink onSearch={(tag) => console.log(tag)} />
        <MainWrapper>
          <Ads><p>Google adsense here</p></Ads>
          <MainContent>
            {post.elements.map((element, index) => (
              <RenderCardElement key={index} element={element} />
            ))}
          </MainContent>
          <Ads><p>Google adsense here</p></Ads>
        </MainWrapper>
      </Layout>
    );
  };